import { getHdc1Dot5MembershipId } from "../builders/getHdc1Dot5MembershipId";
import { getHdc1Dot5MembershipDetails } from "../builders/getHdc1Dot5MembershipDetails";
import { hdcAutoPayUpcomingMock, hdcInfo } from "../builders/createInsuranceBill";
import { cigHdcAutoPayBill } from "../builders/createCigBill";
import { omniUsSecondGearMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 2;

export const dennisReynolds: MockPersona = {
  key: "dennisReynolds",
  name: "Dennis Reynolds",
  description: "🇺🇸 | No policies | HDC 1.5 Single-tier | Upcoming HDC Bill (autopay)",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcAutoPayBill("1.5", { id: "1" })],
      },
      policies: {
        usa: [],
        canada: [],
      },
    },
    hdc: {
      fetch1Dot5MembershipId: getHdc1Dot5MembershipId("HDC01981376"),
      fetch1Dot5MembershipDetails: getHdc1Dot5MembershipDetails({
        level: hdcLevel,
      }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "dennis@reynolds.com",
            firstName: "Dennis",
            middleName: "",
            lastName: "Reynolds",
            mailingAddress: {
              line1: "9241 Roosevelt Blvd",
              line2: "",
              city: "Philadelphia",
              state: "PA",
              postalCode: "19114",
              country: "USA",
            },
            preferredPhone: "2152098522",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000008",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: omniUsSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcAutoPayUpcomingMock({ id: "1" })],
          outstandingBalance: hdcInfo[hdcLevel - 1].cost,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
